define(function (require) {
    var $ = require("jquery");
    var geocoder = require("@modules/tools/geocoder");
    var utility = require("@modules/tools/helpfulToolUtility");
    var apiUrl = window.scan && window.scan.apiUrl ? window.scan.apiUrl : "";
    var scanTranslations = require("scanTranslations");

    return {
        /**
         * Returns a jQuery promise for the provider search results.
         *
         * @param {} parameters Object of search parameters.
         * @returns {} Object with CurrentResults array, TotalResults integer, Facets array.
         */
        getResults: function (parameters, facetsOnly) {
            return geocoder.geocode(parameters.zipOrAddress).then(function (coordinates) {
                if (!coordinates && parameters.zipOrAddress) {
                    var deferred = $.Deferred();
                    deferred.resolve({
                        TotalResults: 0,
                        CurrentResults: [],
                        Facets: {
                            Name: [],
                            Radius: utility.mapFacets(window.scan.emptyRadiusOptions)
                        }
                    });
                    return deferred.promise();
                }

                parameters.facetsOnly = facetsOnly ? true : false; // force to a boolean

                if (coordinates) {
                    parameters.latitude = coordinates.lat;
                    parameters.longitude = coordinates.lng;
                }

                return $.getJSON(apiUrl + "/api/hospitalsearch/results", parameters).then(function (hospitalResults) {
                    return scanTranslations.getInstance().then(function (scanTranslationInstance) {
                        // we need to return the lat/lng of the point we searched against, if any.
                        if (coordinates) {
                            hospitalResults.latitude = coordinates.lat;
                            hospitalResults.longitude = coordinates.lng;
                        }

                        hospitalResults.Facets.Name = utility.mapFacets(hospitalResults.Facets.Name);
                        hospitalResults.Facets.Radius = utility.mapFacets(hospitalResults.Facets.Radius);
                        var tmpVillageHealth = utility.mapFacets(hospitalResults.Facets.IsVillageHealth);
                        hospitalResults.Facets.IsVillageHealth = utility.mapProperty(tmpVillageHealth, { true: scanTranslationInstance.translate("village_health_only_providers") }, "value", "text", true);
                        return hospitalResults;
                    });
                });
            });
        }
    };
});
